import { createFileRoute } from "@tanstack/react-router";
import { requireRole, requireUnitAdmin } from "@/utils/route-guards";

/**
 * The unit's houses (Jira NAV-96, ADR 0025) — where the unit's admin creates a
 * house, renames it, and decides which of the unit's sign-in domains resolve
 * to it.
 *
 * For the **unit's** admin only. A house's admin is a BU admin too, and the
 * rules would refuse every write on this page — a house does not create its
 * neighbours — so they are sent to their dashboard rather than shown a page of
 * buttons that fail (the screen is a convention, the rules the boundary).
 */
export const Route = createFileRoute("/bu-admin/houses")({
  beforeLoad: ({ context, location }) => {
    requireRole(context, location, ["bu_admin", "super_admin"]);
    requireUnitAdmin(context);
  },
});
